import React from 'react';
import { FullPanelGoogleMap } from './view/fullPanelGoogleMap';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'FullPanelGoogleMap', 
  itemElt: (item, cmsOption) => <FullPanelGoogleMap item={item} cmsOption={cmsOption} />
}